import { createApp } from "vue";
import "./variables.css";
import "./style.css";
import App from "./App.vue";

createApp(App).mount("#app");
